<template>
  <div class="bill-market-picking-page">
    <div class="bill-market-picking-information" id="page-top">
      <a-row class="ant-row-one">
        <a-col :span="12">
          <span class="a-col-title" v-if="dataDetails.reverseFlag==1">红冲原因：</span>
          <span class="a-col-value" v-if="dataDetails.reverseFlag==1">{{ dataDetails.reverseReason }}</span>
        </a-col>
        <a-col style="display:flex;justify-content: flex-end;" :span="12">
          <a-col>
            <span class="a-col-title">单据单号：</span>
            <span class="a-col-value"> {{ dataDetails.outboundCode }}</span>
          </a-col>
          <a-col style="margin-left: 106px">
            <span class="a-col-title">单据日期：</span>
            <span class="a-col-value">{{ dataDetails.outboundDate }}</span>
          </a-col>
        </a-col>
      </a-row>
      <a-row class="ant-row-two">
        <a-col>
          <span class="a-col-title">往来单位：</span>
          <span class="a-col-value">{{ dataDetails.contactCustomerName }}</span>
        </a-col>
        <a-col>
          <span class="a-col-title">出库仓库：</span>
          <span class="a-col-value"> {{ dataDetails.storageName }}</span>
        </a-col>
        <a-col>
          <span class="a-col-title">经办人：</span>
          <span class="a-col-value"> {{ dataDetails.transactorName }}</span>
        </a-col>
      </a-row>
    </div>

    <div class="bill-market-picking-table" :style="{height: contentHeight+'px'}">
      <a-table :columns="columns" :dataSource="dataDetails.itemList" :pagination="false" rowKey="id" :scroll="{ y: (tableHeight) }" bordered>
        <!-- 序号 -->
        <template slot="serialNum" slot-scope="text, record, index">
          <span>{{ index+1 }}</span>
        </template>
        <!-- 商品名称 -->
        <template slot="productName" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <img src="@/assets/image/zengpin.png" style="width: 22px;margin-right: 5px" v-if="record.giftFlag==1">
              <img src="@/assets/image/manage_zong@2x.png" style="width: 22px" v-if="record.assemblyFlag==1">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 商品编号 -->
        <template slot="productCode" slot-scope="text">
          <a-tooltip>
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 商品库位 -->
        <template slot="locationName" slot-scope="text">
          <a-tooltip>
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 商品备注 -->
        <template slot="remark" slot-scope="text" v-if="text">
          <a-tooltip>
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 底部合计 -->
        <template slot="footer">
          <div class="footer-total-amount">
            <div class="footer-total-amount-left" style="width: 80px">
              <span class="title">小计</span>
            </div>
            <div class="footer-total-amount-right" v-if="footerDataSource.length>0">
              <span class="right-col">数量：{{ footerDataSource[0].productCount }}</span>
            </div>
          </div>
        </template>
      </a-table>
    </div>

    <!-- 底部按钮组件 -->
    <public-footer :buttonList="buttonList"></public-footer>
  </div>
</template>
<script>
import pick from 'lodash.pick'
import publicFooter from '@/components/module/publicFooter.vue'
import { tableWidth } from "@/mixins/tableWidth"
import { getBillDetails } from "@/utils/api"
export default {
  name: 'billMarketPicking',
  mixins: [tableWidth],
  components: {
    publicFooter,
  },
  data () {
    return {
      columns: [
        {
          width: 80,
          title: "序号",
          align: "center",
          dataIndex: "serialNum",
          ellipsis: true,
          scopedSlots: { customRender: "serialNum" },
        }, {
          title: "商品名称",
          dataIndex: "productName",
          ellipsis: true,
          scopedSlots: { customRender: "productName" },
        }, {
          title: "商品编号",
          dataIndex: "productCode",
          ellipsis: true,
          scopedSlots: { customRender: "productCode" },
        }, {
          title: "规格",
          ellipsis: true,
          dataIndex: "productSpecification",
        }, {
          title: "型号",
          ellipsis: true,
          dataIndex: "productModel",
        }, {
          title: "数量",
          align: "right",
          dataIndex: "productCount",
          ellipsis: true,
        }, {
          title: "单位",
          dataIndex: "productUnit",
          ellipsis: true,
        }, {
          title: "出库库位",
          ellipsis: true,
          dataIndex: "locationName",
        }
      ],
      dataSource: [],
      buttonList: [
        {
          id: 7,
          text: "打印",
          templateType: 101,
        }
      ],
      footerDataSource: [{
        serialNum: '',
        productName: '',
        productCode: '',
        productSpecification: '',
        productModel: '',
        productUnit: '',
        productCount: 0,
        price: '',
        totalAmount: 0,
        locationName: '',
        remark: ''
      }],
      contentHeight: '',
      tableHeight: '',
      urlList: {
        details: '/storage/api/outbound/findPickingListById'
      },
      dataDetails: {},
      billId: null
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.billId = to.query.id
    this.getBillDetails();
    next()
  },
  activated () {
    // 表格高度计算
    let _that = this
    setTimeout(function() {
      let tdHeight = document.getElementsByTagName('tr')[0].offsetHeight
      let header = document.getElementById("header").offsetHeight;
      let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
      let pageHeight = document.getElementById('content').offsetHeight
      let makeTop = document.getElementById('page-top').offsetHeight
      _that.contentHeight = pageHeight - makeTop - header - breadcrumb - tdHeight*0.96
      _that.tableHeight = _that.contentHeight - tdHeight*2
    }, 50)
    this.billId = this.$route.query.id
    this.getBillDetails()
  },
  methods: {
    // 获取详情
    getBillDetails () {
      let header = {}
      let params = {}
      let data = {
        id: this.billId,
        companyStoreId: this.$store.state.userInfo.companyStoreId
      }
      this.$store.state.isLoding = true
      getBillDetails(this.urlList.details, params, header, data).then((res) => {
        if (res.code == 200) {
          this.dataDetails = res.result
          this.dataSource = res.result.itemList
          if (this.dataDetails.paymentAccountVOList && this.dataDetails.paymentAccountVOList.length > 0) {
            this.accountsName = this.dataDetails.paymentAccountVOList[0].financeAccountName
          } else {
            this.accountsName = '多账户'
          }
          this.footerDataSource[0].productCount = 0
          this.dataSource.map(item => {
            this.footerDataSource[0].productCount += item.productCount
          })
          this.$store.state.isLoding = false
        } else {
          this.$message.warn(res.logMessage);
        }
      })
    }
  }
}
</script>

<style lang="scss">
.bill-market-picking-page {
  .bill-market-picking-information {
    padding: 15px 40px;
    background-color: #ffffff;
    .ant-row-one {
      padding: 8px 0;
      display: flex;
      justify-content: space-between;
    }
    .ant-row-two {
      padding: 8px 0;
      display: flex;
      flex-wrap: wrap;
      .ant-col {
        padding-right: 80px;
      }
    }
  }
  .bill-market-picking-table {
    margin-top: 16px;
    background-color: #ffffff;
    .ant-table-wrapper {
      padding: 0;
    }
    .ant-table-thead {
      tr {
        th {
          height: 50px;
          padding: 0 16px !important;
        }
      }
    }
    .ant-table-tbody {
      tr {
        td {
          padding: 0 10px !important;
          height: 54px;
        }
        .ant-input {
          border-radius: 0 !important;
        }
        .blank-input {
          width: 100%;
          height: 54px;
        }
        .text-overflow {
          width: 100%;
          height: 36px;
          line-height: 36px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .ant-table-footer {
      padding: 0 5px 0 0;
      td:last-child {
        border-right: 0 !important;
      }
      .ant-table-body {
        border: 0;
      }
    }
  }
}
</style>
